import { DEFAULT } from './default'
import { MOG } from './mog'
import { PEPE } from './pepe'

export const COMET_THEMES = { DEFAULT, MOG, PEPE }
